<template>
    <div class="staff-contact-info">
        <div class="flex w-full mb-4 mr-3">
            <vx-basic-icon class="mr-3" icon="SmartphoneIcon" />
            <component :key="staff.id" :is="hideMobile ? 'vx-spoiler' : 'div'" class="mr-3">
                <vx-phone :value="staff.mobilePhone" mobile hide-icon />
            </component>
            <span v-if="hideMobile" class="text-sm">
                {{ doNotDistributeText }}
            </span>
        </div>
        <vx-phone class="w-full mb-4 mr-3" :value="staff.workPhone" />
        <user-teams-link v-if="!isCurrentUser" class="w-full mb-4 mr-3" :staff="staff" />
        <vx-email class="mr-3" style="width: 500%" :value="staff.workEmail" />
        <template v-if="canSeeEmailSignature">
            <a class="signature-link" @click="showEmailSignature = true">
                Show Email Signature
                <vx-basic-icon size="3" icon="ExternalLinkIcon"></vx-basic-icon>
            </a>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import UserTeamsLink from '../UserTeamsLink.vue'

export default {
    name: 'staff-contact-info',
    components: { UserTeamsLink },
    props: {
        staff: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            doNotDistributeText: 'Do not distribute',
            showEmailSignature: false
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'user/profile'
        }),
        hideMobile() {
            return (
                this.staff.doNotDistributeMobile &&
                this.staff.mobilePhone &&
                !(this.staff.id == this.userInfo.id)
            )
        },
        isCurrentUser() {
            return this.userInfo.id == this.staff.id
        },
        currentUserIsAdmin() {
            return this.userRoles.any((x) => ['SuperUser', 'UserAdmin'].contains(x))
        },
        userRoles() {
            return this.userInfo.roles || []
        },
        canSeeEmailSignature() {
            return this.isCurrentUser || this.currentUserIsAdmin
        }
    }
}
</script>

<style lang="scss" scoped>
.signature-link {
    margin-left: 2.1rem;
    cursor: pointer;
    text-decoration: none !important;
    vertical-align: super;
    font-size: smaller;
}
</style>

<style lang="scss">
.prompt-container .vs-dialog {
    width: fit-content;
    max-width: 70% !important;
}
</style>
